import { AppConfigData } from '@99designs/apps/spa/common/AppConfigContext';
import isSsr from '@99designs/apps/spa/common/Ssr/isSsr';
import path from 'path';

// This sets the public path for webpack
if (isSsr()) {
    // eslint-disable-next-line no-undef
    __webpack_public_path__ = `${process.env.SPA_ASSET_ORIGIN}${path.join(
        process.env.SPA_ASSET_PATH || ''
    )}`;
} else {
    const appConfigNode = document.getElementById('app-config-init-data');
    const appConfigData: AppConfigData = appConfigNode?.textContent
        ? JSON.parse(appConfigNode.textContent)
        : {};
    /* eslint-disable-next-line no-undef */
    __webpack_public_path__ = `${appConfigData.webpackPublicPath}/`;
}

export {};
